<template>
  <div >
    <ul class="details-list">
      <li v-for="value in values" :key="value.key">
        <label>{{ value.key }}</label>
        <span v-if="value.clickAction">
          <a href="#"  role="button" @click.prevent="value.clickAction()">
            <span>{{ value.value }}</span>
            <i v-if="value.icon" :class="getIconClassName(value.icon)"/>
          </a>
        </span>
        <span v-else>{{ value.value }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "HistoryDetailsKeyValueList",
  props: {
    values: { type: Array, required: true }
  },
  methods: {
    getIconClassName(icon) {
      return `ml-1 fa ${icon}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.details-list {
  list-style-type: none;
  padding: 0;
}
label {
  font-weight: 500;
  margin-right: 8px;
}
label::after {
  content: ":";
}
.details-list label {
  margin-bottom: 0;
}
.details-list label + span {
  float: right;
}
.details-list > li {
  padding: 3px 8px;
  overflow: auto;
}
.details-list > li:nth-of-type(odd) {
  background-color: #f0f0f0;
}

</style>



// WEBPACK FOOTER //
// src/history/modals/HistoryDetailsKeyValueList.vue